// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section[data-v-5dedb299]{text-align:center;width:100%;height:100vh;display:flex}.logout-content[data-v-5dedb299]{width:300px;margin:auto;background-color:hsla(41,70%,95%,.95);padding:60px 20px;text-align:center;border-radius:4px}i[data-v-5dedb299]{display:block;font-size:60px}.btn[data-v-5dedb299],i[data-v-5dedb299]{margin-top:15px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
